import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Icon from '~/components/common/icon';

/**
 * Render Free Choice Question Type
 *
 * @callback handleAnswerUpdate
 * @callback handleInputChange
 * @callback handleShowForm
 * @param {Object} props
 * @param {handleAnswerUpdate} props.handleAnswerUpdate
 * @param {handleInputChange} props.handleInputChange
 * @param {handleShowForm} props.handleShowForm
 * @param {string} props.answer
 * @param {boolean} props.updated
 * @param {boolean} props.showForm
 */
const QuestionTypeFree = ( {
	handleAnswerUpdate,
	handleInputChange,
	handleShowForm,
	answer,
	updated,
	showForm,
} ) => (
	<div className="ld-answer-editor">
		{ showForm ? (
			<Fragment>
				{ LearnDashData.labels.questions_types_description
					.free_answer && (
					<p className="description">
						{
							LearnDashData.labels.questions_types_description
								.free_answer
						}
					</p>
				) }
				<textarea
					name="answer"
					value={ answer }
					onChange={ handleInputChange }
					autoFocus
				/>
				<div className="ld-answer-editor-actions">
					<button
						className="is-button is-primary"
						onClick={ handleAnswerUpdate }
					>{ `${ LearnDashData.i18n.update_answer }` }</button>
					<span className="ld-trash">
						<button
							className="is-button components-button is-default"
							onClick={ handleShowForm }
						>{ `${ LearnDashData.i18n.cancel }` }</button>
					</span>
					{ updated && (
						<span className="ld-answer-updated">{ `${ LearnDashData.i18n.answer_updated }` }</span>
					) }
				</div>
			</Fragment>
		) : (
			<button
				className="ld-answer-read-only ld-button-reset"
				onClick={ handleShowForm }
			>
				<span>{ `${ LearnDashData.i18n.answer }` }</span>
				{ '' === answer && (
					<div
						dangerouslySetInnerHTML={ {
							__html: `${ LearnDashData.i18n.edit_answer }`,
						} }
					/>
				) }
				{ '' !== answer && (
					<pre dangerouslySetInnerHTML={ { __html: answer } } />
				) }
				<Icon icon="pencil" />
				<span className="screen-reader-text">{ `${ LearnDashData.i18n.edit }` }</span>
			</button>
		) }
	</div>
);

/**
 * Valid props
 */
QuestionTypeFree.propTypes = {
	handleShowForm: PropTypes.func,
	handleAnswerUpdate: PropTypes.func,
	handleInputChange: PropTypes.func,
	answer: PropTypes.string,
	updated: PropTypes.bool,
	showForm: PropTypes.bool,
};

export default QuestionTypeFree;
